import { useMutation } from "@tanstack/react-query";
import { MissionManagerPayload } from "models/Mission";
import { updateMissionManagerSettings } from "services/mission";
import { useRootStore } from "store";

export const useUpdateMissionManagerSettings = (
  callback?: Function,
  errorCallback?: Function,
  alertOnError?: boolean
) => {
  const {
    authStore,
    uiStore: { setApiErrorToast },
    missionSpecStore: { updateMissionObject },
  } = useRootStore();

  return useMutation(
    (params: { mid: string; payload: MissionManagerPayload }) =>
      updateMissionManagerSettings(authStore, params.payload, params.mid),
    {
      onSuccess: (data) => {
        data && updateMissionObject(data);
        callback && callback(data);
      },
      onError: (error: unknown) => {
        alertOnError && setApiErrorToast(error, "Failed to update mission");
        errorCallback && errorCallback(error);
      },
    }
  );
};
